import React from 'react'
import { Routes, Route } from "react-router-dom";

import MyHeader from './components/MyHeader';
import MyFooter from './components/MyFooter';
import CookieBanner from './components/CookieBanner';

import Home from './pages/Home';
import Contact from './pages/Contact';
import About from './pages/About';
import KozmetikUygulamalar from './pages/KozmetikUygulamalar';
import LazerUygulamalari from './pages/LazerUygulamalari/MainLazerUygulamalari';
import TaniTedaviMain from './pages/TaniTedaviMain';
import LekeTedavisi from './pages/LazerUygulamalari/LekeTedavisi';
import VarisTedavisi from './pages/LazerUygulamalari/VarisTedavisi';
import LazerEpilasyon from './pages/LazerUygulamalari/LazerEpilasyon';
import CiltYenileme from './pages/LazerUygulamalari/CiltYenileme';

import './App.css';


function App() {
  return (
    <div className="App">
      <MyHeader />
      <Routes>
        <Route element={<Home />} path="/" />
        <Route element={<Contact />} path="/iletisim" />
        <Route element={<About />} path="/biyografi" />
        <Route element={<KozmetikUygulamalar />} path="/kozmetik-uygulamalar" />
        <Route element={<TaniTedaviMain />} path="/kozmetik-uygulamalar-2" />
        <Route element={<LazerUygulamalari />} path="/lazer-uygulamalari" />
        <Route element={<LekeTedavisi />} path="/lazer-uygulamalari/leke-tedavisi" />
        <Route element={<VarisTedavisi />} path="/lazer-uygulamalari/kilcal-damar-ve-varis-tedavisi" />
        <Route element={<LazerEpilasyon />} path="/lazer-uygulamalari/lazer-epilasyon" />
        <Route element={<CiltYenileme />} path="/lazer-uygulamalari/cilt-yenileme" />
      </Routes>
      <MyFooter />
      <CookieBanner />
    </div >
  );
}

export default App;
